import * as React from "react";
import type { SVGProps } from "react";

const SvgCloseThin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    {...props}
  >
    <g fill="currentColor" fillRule="evenodd">
      <path d="m3.707 3 9.9 9.9-.708.706-9.9-9.9z" />
      <path d="M3 12.9 12.9 3l.706.707-9.9 9.9z" />
    </g>
  </svg>
);
export default SvgCloseThin;
